import React from 'react'
import { Control } from 'react-redux-form'
import icon from 'assets/icons/expand_more_black_material_icon.svg'
import styled, { css } from 'styled-components'

export interface StyledSelectFieldProps {
  model?: string
  name?: string
  value?: string | number
  id?: string
  children?: React.ReactNode | React.ReactNode[]
  className?: string
  readOnly?: boolean
  onChange?: any
  updateOn?: any
  validateOn?: any
  validators?: any
  multiple?: boolean
}

const StyledControlSelectField = styled(Control.select)`
  background-color: ${({ theme }) => theme.color.grey07};
  border: none;
  color: ${({ theme }) => theme.color.bodyText};
  height: ${({ theme }) => theme.space.s40};
  line-height: ${({ theme }) => theme.space.s24};
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  padding: ${({ theme }) => theme.space.s8} ${({ theme }) => theme.space.s16};
  outline: none;
  overflow: auto;

  select& {
    appearance: none;
    cursor: pointer;
    background-repeat: no-repeat;
    background-size: ${({ theme }) => theme.space.s20}
      ${({ theme }) => theme.space.s20};
    background-position: ${({ theme }) =>
      `right ${theme.space.s16} top ${theme.space.s12}`};
    background-image: url(${icon});

    &::-ms-expand {
      display: none;
    }
  }
`

export const SelectStyle = css`
  background-color: ${({ theme }) => theme.color.grey07};
  border: none;
  color: ${({ theme }) => theme.color.bodyText};
  height: ${({ theme }) => theme.space.s40};
  line-height: ${({ theme }) => theme.space.s24};
  width: 100%;
  max-width: 100%;
  padding: ${({ theme }) => theme.space.s8} ${({ theme }) => theme.space.s16};
  outline: none;
  overflow: auto;

  appearance: none;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: ${({ theme }) => theme.space.s20}
    ${({ theme }) => theme.space.s20};
  background-position: ${({ theme }) =>
    `right ${theme.space.s16} top ${theme.space.s12}`};
  background-image: url(${icon});

  &::-ms-expand {
    display: none;
  }
`

const StyledSelectField = styled.select`
  ${SelectStyle};
`

export const StyledSelect = ({
  model,
  children,
  className,
  readOnly = false,
  multiple = false,
  onChange,
  updateOn = 'change',
  validateOn = 'change',
  validators,
  ...props
}: StyledSelectFieldProps) => {
  if (model) {
    return (
      <StyledControlSelectField
        {...props}
        model={model}
        className={className}
        readOnly={readOnly}
        onChange={onChange}
        updateOn={updateOn}
        validateOn={validateOn}
        validators={validators}
        multiple={multiple}
      >
        {children}
      </StyledControlSelectField>
    )
  }

  return (
    <StyledSelectField {...props} onChange={onChange}>
      {children}
    </StyledSelectField>
  )
}
